import styled from 'styled-components';
import { AnimatedBackground } from './Loader.style';

const DEFAULT_HEIGHT = 400;

export const BlockLoaderWrapper = styled(AnimatedBackground)<{
  height?: number;
  'margin-bottom'?: number;
}>`
  background-color: #f3f4f6;
  height: ${(props) => `${props.height || DEFAULT_HEIGHT}px`};
  margin-bottom: ${(props) => `${props['margin-bottom'] || 0}px`};
`;

export const ExpandableBlockLoader = styled(AnimatedBackground)`
  background-color: #f3f4f6;
  height: 100%;
  margin-bottom: 0;
`;
